import Button, { BUTTON_VARIANT } from "@/common/elements/Button";
import Table from "@/common/elements/Table";
import { useEffect, useState } from "react";
import EditDetentionsModal from "./EditDetentionsModal";
import { ActionsHeader, DetentionListContainer } from "./styles";
import { useSelector } from "react-redux";
import {
  getRefListNameByID,
  hasCheckSecurity,
  isNonEmptyVariable,
} from "@/util/common_function";
import { v4 as uuidV4 } from "uuid";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import {
  MODULES_LIST_WITH_ID,
  SUB_MODULES_LIST_WITH_ID,
} from "@/util/common_variable";

const headers = [
  { key: "bookingIdWithSuffix", text: "ID" },
  {
    key: "housingAgency",
    text: "Housing Agency",
  },
  { key: "holdReason", text: "Hold Reason" },
  { key: "incarcerationDateTime", text: "Incarcerated" },
  { key: "releaseDateTime", text: "Released" },
  { key: "lengthOfStay", text: "Length of Stay" },
  { key: "releaseReason", text: "Release Reason" },
];

const DetentionList = ({ switchToAddDetention }) => {
  const bookings = useSelector((state) => state?.bookings?.bookings);
  const [modalShown, setModalShown] = useState(false);
  const [allDetentionData, setAllDetentionData] = useState([]);
  const [selectDetentionData, setSelectDetentionData] = useState(null);
  const [showEdit, setShowEdit] = useState(false);

  useEffect(() => {
    const data = [];
    bookings?.detentions?.forEach((d) => {
      const obj = Object.assign({}, d);
      obj.bookingIdWithSuffix =
        bookings?.bookingNumber + "" + d?.detentionSuffix;
      obj.detentionIdWithSuffix = d?.detentionID + "" + d?.detentionSuffix;
      d?.detentionsArrestReports?.forEach((da) => {
        obj.housingAgency = da?.housingAgency;
        obj.holdReason = getRefListNameByID(
          "Inmate_Hold_Reason",
          da?.holdReasonId
        );
        obj.releaseReason = getRefListNameByID(
          "ChargeClearance",
          da?.releaseReasonId
        );
        obj.incarcerationDateTime = `${
          isNonEmptyVariable(da?.incarcerationDate)
            ? da?.incarcerationDate + " " + da?.incarcerationTime
            : ""
        }`;

        obj.releaseDateTime = `${
          isNonEmptyVariable(da?.releaseDate)
            ? da?.releaseDate + " " + da?.releaseTime
            : ""
        }`;
      });
      obj.uuid = uuidV4();
      data.push(obj);
    });
    setAllDetentionData(() => data);
  }, [bookings]);

  const onModalShow = () => {
    setModalShown(true);
  };

  const onModalHide = () => {
    setSelectDetentionData(null);
    setModalShown(false);
  };

  const selectRowDetentionFn = (values) => {
    setSelectDetentionData(() => ({ ...values }));
    setShowEdit(() => true);
  };

  const cancelAction = () => {
    setShowEdit(() => false);
    setSelectDetentionData(null);
  };

  return (
    <>
      <DetentionListContainer>
        <ActionsHeader className="action-header-row">
          <div className="left"></div>
          <div className="right">
            <Button
              variant={BUTTON_VARIANT.DARK}
              disabled={
                !showEdit ||
                !hasCheckSecurity(
                  Security_Types.functionality,
                  Entity_types.subModule,
                  LABELS_CAPITAL.VIEW,
                  MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                  SUB_MODULES_LIST_WITH_ID.Arrest_Report
                )
              }
              onClick={onModalShow}
            >
              Details
            </Button>
            <Button
              variant={BUTTON_VARIANT.DARK}
              disabled={!showEdit}
              onClick={cancelAction}
            >
              Cancel
            </Button>
          </div>
        </ActionsHeader>
        {hasCheckSecurity(
          Security_Types.functionality,
          Entity_types.subModule,
          LABELS_CAPITAL.VIEW,
          MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
          SUB_MODULES_LIST_WITH_ID.Arrest_Report
        ) && (
          <Table
            headers={headers}
            data={allDetentionData}
            onRowClick={selectRowDetentionFn}
            onRowDoubleClick={(value) => {
              selectRowDetentionFn(value);
              onModalShow();
            }}
            selected={selectDetentionData === null}
          />
        )}
      </DetentionListContainer>
      <EditDetentionsModal
        show={modalShown}
        formData={selectDetentionData}
        onHide={onModalHide}
        isEdit={true}
        allDetentionData={allDetentionData}
      />
    </>
  );
};

export default DetentionList;
